module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"clusterLabel":"cluster","articlesCount":"article | articles","sampleLabel":"latest sample"}}')
  delete Component.options._Ctor
}
